import { render, staticRenderFns } from "./bids-item-imgs.vue?vue&type=template&id=42c08b43&"
import script from "./bids-item-imgs.vue?vue&type=script&lang=js&"
export * from "./bids-item-imgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports